import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosCommunication } from "./axios";

export interface IEmailTo {
  address: string;
  name: string;
}

export interface IEmail {
  content: string;
  emails: IEmailTo[];
  subject: string;
  attachments?: {
    filename: string;
    url: string;
  }[];
  bcc?: IEmailTo[];
  cc?: IEmailTo[];
  icalEvent?: {
    filename?: string | undefined;
    content: string;
    method: string;
  };
}

export interface IEmailOptions {
  apply?: ObjectId;
  candidate?: ObjectId;
  workshop?: ObjectId;
}

export interface IPostRawEmails {
  emails: IEmail[];
  options?: IEmailOptions;
}

export const usePostRawEmails = () => {
  const [state, execute, cancel] = axiosCommunication<void, IPostRawEmails, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostRawEmails) => {
      return execute({
        url: "/rawEmails",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
